import {
  LOCATION_LIST_REQUEST,
  LOCATION_LIST_SUCCESS,
  LOCATION_LIST_FAIL,
  LOCATION_DETAILS_REQUEST,
  LOCATION_DETAILS_SUCCESS,
  LOCATION_DETAILS_FAIL,
  LOCATION_CREATE_REQUEST,
  LOCATION_CREATE_SUCCESS,
  LOCATION_CREATE_FAIL,
  LOCATION_CREATE_RESET,
  LOCATION_UPDATE_REQUEST,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_UPDATE_FAIL,
  LOCATION_UPDATE_RESET,
  LOCATION_DELETE_REQUEST,
  LOCATION_DELETE_SUCCESS,
  LOCATION_DELETE_FAIL,
  LOCATION_DELETE_RESET,
  CLUB_ACCESS_STATUS,
  VENUE_LIST_REQUEST,
  VENUE_LIST_SUCCESS,
  VENUE_LIST_FAIL,
  VENUE_CREATE_REQUEST,
  VENUE_CREATE_SUCCESS,
  VENUE_CREATE_FAIL,
  VENUE_CREATE_RESET,
  VENUE_ADD_CLUB_REQUEST,
  VENUE_ADD_CLUB_SUCCESS,
  VENUE_ADD_CLUB_FAIL,
  VENUE_ADD_CLUB_RESET,
  CLUB_LIST_REQUEST,
  CLUB_LIST_SUCCESS,
  CLUB_LIST_FAIL,
  CLUB_DETAILS_REQUEST,
  CLUB_DETAILS_SUCCESS,
  CLUB_DETAILS_FAIL,
  CLUB_CREATE_REQUEST,
  CLUB_CREATE_SUCCESS,
  CLUB_CREATE_FAIL,
  CLUB_CREATE_RESET,
  CLUB_UPDATE_REQUEST,
  CLUB_UPDATE_SUCCESS,
  CLUB_UPDATE_FAIL,
  CLUB_UPDATE_RESET,
  CLUB_DELETE_REQUEST,
  CLUB_DELETE_SUCCESS,
  CLUB_DELETE_FAIL,
  CLUB_DELETE_RESET,
  CLUB_STATS_REQUEST,
  CLUB_STATS_SUCCESS,
  CLUB_STATS_FAIL,
  CLUB_ASSIGN_ADMIN_REQUEST,
  CLUB_ASSIGN_ADMIN_SUCCESS,
  CLUB_ASSIGN_ADMIN_FAIL,
  SET_SELECTED_CLUB,
  CLEAR_SELECTED_CLUB,
  // Chip Inventory
  CHIP_INVENTORY_REQUEST,
  CHIP_INVENTORY_SUCCESS,
  CHIP_INVENTORY_FAIL,
  CHIP_INVENTORY_RESET,
  CHIP_INVENTORY_SETUP_REQUEST,
  CHIP_INVENTORY_SETUP_SUCCESS,
  CHIP_INVENTORY_SETUP_FAIL,
  CHIP_INVENTORY_SETUP_RESET,
  CHIP_INVENTORY_ADD_REQUEST,
  CHIP_INVENTORY_ADD_SUCCESS,
  CHIP_INVENTORY_ADD_FAIL,
  CHIP_INVENTORY_ADD_RESET,
  CHIP_INVENTORY_REMOVE_REQUEST,
  CHIP_INVENTORY_REMOVE_SUCCESS,
  CHIP_INVENTORY_REMOVE_FAIL,
  CHIP_INVENTORY_REMOVE_RESET,
  CHIP_INVENTORY_HISTORY_REQUEST,
  CHIP_INVENTORY_HISTORY_SUCCESS,
  CHIP_INVENTORY_HISTORY_FAIL,
  CHIP_INVENTORY_SUMMARY_REQUEST,
  CHIP_INVENTORY_SUMMARY_SUCCESS,
  CHIP_INVENTORY_SUMMARY_FAIL,
  CHIP_INVENTORY_RECONCILE_REQUEST,
  CHIP_INVENTORY_RECONCILE_SUCCESS,
  CHIP_INVENTORY_RECONCILE_FAIL,
  CHIP_INVENTORY_RECONCILE_RESET,
} from '../constants/clubConstants';

// ==================== LOCATION REDUCERS ====================

export const venueListReducer = (state = { venues: [], meta: {} }, action) => {
  switch (action.type) {
    case VENUE_LIST_REQUEST:
      return { loading: true, venues: [], meta: {} };
    case VENUE_LIST_SUCCESS:
      return {
        loading: false,
        venues: action.payload.data || [],
        meta: action.payload.meta || {},
      };
    case VENUE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const venueCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case VENUE_CREATE_REQUEST:
      return { loading: true };
    case VENUE_CREATE_SUCCESS:
      return { loading: false, success: true, venue: action.payload.data };
    case VENUE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case VENUE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const venueAddClubReducer = (state = {}, action) => {
  switch (action.type) {
    case VENUE_ADD_CLUB_REQUEST:
      return { loading: true };
    case VENUE_ADD_CLUB_SUCCESS:
      return { loading: false, success: true, data: action.payload.data };
    case VENUE_ADD_CLUB_FAIL:
      return { loading: false, error: action.payload };
    case VENUE_ADD_CLUB_RESET:
      return {};
    default:
      return state;
  }
};

export const locationListReducer = (state = { locations: [] }, action) => {
  switch (action.type) {
    case LOCATION_LIST_REQUEST:
      return { loading: true, locations: [] };
    case LOCATION_LIST_SUCCESS:
      return {
        loading: false,
        locations: action.payload.data,
        pagination: action.payload.pagination,
      };
    case LOCATION_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const locationDetailsReducer = (state = { location: {} }, action) => {
  switch (action.type) {
    case LOCATION_DETAILS_REQUEST:
      return { loading: true, ...state };
    case LOCATION_DETAILS_SUCCESS:
      return { loading: false, location: action.payload };
    case LOCATION_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const locationCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case LOCATION_CREATE_REQUEST:
      return { loading: true };
    case LOCATION_CREATE_SUCCESS:
      return { loading: false, success: true, location: action.payload.data };
    case LOCATION_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case LOCATION_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const locationUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case LOCATION_UPDATE_REQUEST:
      return { loading: true };
    case LOCATION_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        location: action.payload.data,
        message: action.payload.message,
      };
    case LOCATION_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case LOCATION_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const locationDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case LOCATION_DELETE_REQUEST:
      return { loading: true };
    case LOCATION_DELETE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case LOCATION_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case LOCATION_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// ==================== CLUB REDUCERS ====================

export const clubListReducer = (state = { clubs: [] }, action) => {
  switch (action.type) {
    case CLUB_LIST_REQUEST:
      return { loading: true, clubs: [] };
    case CLUB_LIST_SUCCESS:
      return {
        loading: false,
        clubs: action.payload.data,
        pagination: action.payload.pagination,
      };
    case CLUB_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const clubDetailsReducer = (state = { club: {} }, action) => {
  switch (action.type) {
    case CLUB_DETAILS_REQUEST:
      return { loading: true, ...state };
    case CLUB_DETAILS_SUCCESS:
      return { loading: false, club: action.payload };
    case CLUB_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const clubCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CLUB_CREATE_REQUEST:
      return { loading: true };
    case CLUB_CREATE_SUCCESS:
      return { loading: false, success: true, club: action.payload.data };
    case CLUB_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case CLUB_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const clubUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case CLUB_UPDATE_REQUEST:
      return { loading: true };
    case CLUB_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        club: action.payload.data,
        message: action.payload.message,
      };
    case CLUB_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case CLUB_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const clubDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CLUB_DELETE_REQUEST:
      return { loading: true };
    case CLUB_DELETE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CLUB_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case CLUB_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const clubStatsReducer = (state = { stats: {} }, action) => {
  switch (action.type) {
    case CLUB_STATS_REQUEST:
      return { loading: true, stats: {} };
    case CLUB_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case CLUB_STATS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const clubAssignAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case CLUB_ASSIGN_ADMIN_REQUEST:
      return { loading: true };
    case CLUB_ASSIGN_ADMIN_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CLUB_ASSIGN_ADMIN_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ==================== SELECTED CLUB REDUCER ====================

const savedClubId = localStorage.getItem('selectedClub');

export const selectedClubReducer = (state = { clubId: savedClubId || null }, action) => {
  switch (action.type) {
    case SET_SELECTED_CLUB:
      return { clubId: action.payload };
    case CLEAR_SELECTED_CLUB:
      return { clubId: null };
    default:
      return state;
  }
};

// ==================== CHIP INVENTORY REDUCERS ====================

export const chipInventoryReducer = (state = { inventory: null }, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_REQUEST:
      return { loading: true, inventory: null };
    case CHIP_INVENTORY_SUCCESS:
      return { loading: false, inventory: action.payload };
    case CHIP_INVENTORY_FAIL:
      return { loading: false, error: action.payload };
    case CHIP_INVENTORY_RESET:
      return { inventory: null };
    default:
      return state;
  }
};

export const chipInventorySetupReducer = (state = {}, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_SETUP_REQUEST:
      return { loading: true };
    case CHIP_INVENTORY_SETUP_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CHIP_INVENTORY_SETUP_FAIL:
      return { loading: false, error: action.payload };
    case CHIP_INVENTORY_SETUP_RESET:
      return {};
    default:
      return state;
  }
};

export const chipInventoryAddReducer = (state = {}, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_ADD_REQUEST:
      return { loading: true };
    case CHIP_INVENTORY_ADD_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CHIP_INVENTORY_ADD_FAIL:
      return { loading: false, error: action.payload };
    case CHIP_INVENTORY_ADD_RESET:
      return {};
    default:
      return state;
  }
};

export const chipInventoryRemoveReducer = (state = {}, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_REMOVE_REQUEST:
      return { loading: true };
    case CHIP_INVENTORY_REMOVE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CHIP_INVENTORY_REMOVE_FAIL:
      return { loading: false, error: action.payload };
    case CHIP_INVENTORY_REMOVE_RESET:
      return {};
    default:
      return state;
  }
};

export const chipInventoryHistoryReducer = (state = { transactions: [], pagination: {} }, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_HISTORY_REQUEST:
      return { loading: true, transactions: [], pagination: {} };
    case CHIP_INVENTORY_HISTORY_SUCCESS:
      return {
        loading: false,
        transactions: action.payload.transactions,
        pagination: action.payload.pagination,
      };
    case CHIP_INVENTORY_HISTORY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const chipInventorySummaryReducer = (state = { summary: null }, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_SUMMARY_REQUEST:
      return { loading: true, summary: null };
    case CHIP_INVENTORY_SUMMARY_SUCCESS:
      return { loading: false, summary: action.payload };
    case CHIP_INVENTORY_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const chipInventoryReconcileReducer = (state = {}, action) => {
  switch (action.type) {
    case CHIP_INVENTORY_RECONCILE_REQUEST:
      return { loading: true };
    case CHIP_INVENTORY_RECONCILE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case CHIP_INVENTORY_RECONCILE_FAIL:
      return { loading: false, error: action.payload };
    case CHIP_INVENTORY_RECONCILE_RESET:
      return {};
    default:
      return state;
  }
};

// Whether the logged-in staff member's assigned clubs are all deactivated
export const clubAccessStatusReducer = (
  state = { blocked: false, message: '', inactiveClubs: [] },
  action
) => {
  switch (action.type) {
    case CLUB_ACCESS_STATUS:
      return {
        blocked: action.payload.blocked === true,
        message: action.payload.message || '',
        inactiveClubs: action.payload.inactiveClubs || [],
      };
    default:
      return state;
  }
};
